import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classnames from "classnames";
import PropTypes from "prop-types";
import { getTranslations } from "../store.js";
import { substituteFromReact } from "../../util/react.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function Translation(props) {
  var code = props.code,
    data = props.data,
    to = props.to,
    onLinkedTextClick = props.onLinkedTextClick,
    linkUrlCode = props.linkUrlCode,
    navigationState = props.navigationState;
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var className = classnames("translation", props.className);
  var linkUrl = linkUrlCode && translate(linkUrlCode);
  var navigate = useNavigate();
  var handleLinkedTextClick = to || onLinkedTextClick ? function (event) {
    if (onLinkedTextClick) {
      onLinkedTextClick(event);
    }
    if (to) {
      if (navigationState) {
        navigate(to, {
          state: navigationState,
          replace: true
        });
      } else {
        navigate(to);
      }
    }
  } : undefined;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("span", {
      className: className,
      "data-code": code,
      children: substituteFromReact(translate(code), data, {
        onLinkedTextClick: handleLinkedTextClick,
        href: linkUrl
      })
    })
  });
}
;
Translation.propTypes = {
  className: PropTypes.string,
  code: PropTypes.string.isRequired,
  data: PropTypes.object,
  onLinkedTextClick: PropTypes.func,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
    pathname: PropTypes.string
  })]),
  linkUrlCode: PropTypes.string
};
export function useTranslation() {
  // Get translations from store
  var translations = useSelector(function (state) {
    return getTranslations(state);
  });
  var translate = useCallback(function (code) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return translations.get(code, "MISSING code \"".concat(code, "\"")).replace(/\{(.*?)\}/g, function (_, key) {
      return key in data ? data[key] : "{".concat(key, "}");
    });
  }, [translations]);
  var result = useMemo(function () {
    return {
      t: translate,
      translate: translate
    };
  }, [translate]);
  return result;
}